<template>
  <div>
    <section class="section is-main-section" ref="filterstop">
        <b-field :horizontal="isMobile()">
           <b-input v-model="selectedAdUnitCode" />
           <b-select
            v-model="selectedCountryCode">
             <option :value="country.code" v-for="country in countries.all" v-bind:key="`countries-list-${country.code}`">
               {{ country.name }} - {{ country.code }}
             </option>
           </b-select>
           <b-datepicker
              class="form-control"
              style="min-width: 15rem; max-width: 15rem;"
              placeholder="Date..."
              v-model="selectedDates"
              range>
              <b-button
              label="Yesterday"
              type="is-primary"
              icon-left="calendar"
              @click="setSelectedDates('YESTERDAY', 'selectedDates')" />
             <b-button
              label="This Month"
              type="is-primary"
              icon-left="calendar"
              @click="setSelectedDates('THIS_MONTH', 'selectedDates')" />
          </b-datepicker>
          <b-button type="is-primary" @click="view">View!</b-button>
        </b-field>

      </section>

      <section class="section is-main-section" style="padding-top: 0;">
        <b-loading v-model="isLoading"></b-loading>
          <line-chart
            ref="chartScoreData"
            style="height: 20rem;"
            chart-id="big-line-chart1"
            :chart-data="chartScoreData"
            :extra-options="extraOptions"
          >
          </line-chart>

          <line-chart
            ref="chartKeywordsData"
            style="height: 20rem;"
            chart-id="big-line-chart1"
            :chart-data="chartKeywordsData"
            :extra-options="extraOptions"
          >
          </line-chart>

          <line-chart
            ref="chartPerformanceData"
            style="height: 20rem;"
            chart-id="big-line-chart1"
            :chart-data="chartPerformanceData"
            :extra-options="extraOptions"
          >
          </line-chart>

          <line-chart
            ref="chartCPARPCData"
            style="height: 15rem;"
            chart-id="big-line-chart3"
            :chart-data="chartCPARPCData"
            :extra-options="extraOptions"
          >
          </line-chart>

          <line-chart
            ref="chartClicksData"
            style="height: 15rem;"
            chart-id="big-line-chart4"
            :chart-data="chartClicksData"
            :extra-options="extraOptions"
          >
          </line-chart>

          <line-chart
            ref="chartCTRData"
            style="height: 15rem;"
            chart-id="big-line-chart5"
            :chart-data="chartCTRData"
            :extra-options="extraOptions"
          >
          </line-chart>

      </section>
  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from "numeral"
// import * as chartConfig from '@/components/Charts/chart.config'
// import TitleBar from '@/components/TitleBar'
// import HeroBar from '@/components/HeroBar'
// import Tiles from '@/components/Tiles'
import {mapState} from "vuex";
// import moment from 'moment';
// import CardWidget from '@/components/CardWidget'
// import CardComponent from '@/components/CardComponent'
// import LineChart from '@/components/Charts/LineChart'
// import ClientsTableSample from '@/components/ClientsTableSample'
// import Multiselect from 'vue-multiselect'
// import Vue from "vue";
import moment from "moment";
import {numberUtils} from "@/helpers/number-utils";
import {timeUtils} from "@/helpers/time-utils";
import {getTqAnalysis} from "@/services";
import LineChart from '@/components/Charts/LineChart'

export default {
  name: 'TQAnalysisPage',
  components: {
    LineChart,
  },

  created() {

    if(!this.countries.all.length) this.$store.dispatch('countries/getAll');

    let isFiltered = false;

    if(this.$route.query.countryCode){
      this.selectedCountryCode = this.$route.query.countryCode;
      isFiltered = true;
    }

    if(this.$route.query.adUnitCode){
      this.selectedAdUnitCode = this.$route.query.adUnitCode;
      isFiltered = true;
    }

    if(this.$route.query.dateFrom && this.$route.query.dateTo){
      this.selectedDates = [
          moment(this.$route.query.dateFrom).toDate(),
          moment(this.$route.query.dateTo).toDate()
      ];
      isFiltered = true;
    }

    if(isFiltered){
      this.view()
    }
  },

  data () {
    return {

      selectedDates: [moment().subtract(15, 'days').toDate(), moment().toDate() ],
      selectedAdUnitCode: null,
      selectedCountryCode: null,
      data: [],
      isLoading: false,

      dataOptimization: [],
      isLoadingOptimization: false,

      // Charts
      chartColors: {
        default: {
          primary: '#00D1B2',
          info: '#209CEE',
          danger: '#FF3860',
          dangerDark: '#992039',
          warning: '#FF5900',
          warningDark: '#9e3e05',
        }
      },
      extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true
          },
          responsive: true,
          tooltips: {
            backgroundColor: '#f5f5f5',
            titleFontColor: '#333',
            bodyFontColor: '#666',
            bodySpacing: 4,
            xPadding: 12,
            mode: 'nearest',
            intersect: 0,
            position: 'nearest'
          },
          scales: {
            yAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(29,140,248,0.0)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  padding: 20,
                  fontColor: '#9a9a9a'
                }
              }
            ],

            xAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(225,78,202,0.1)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  padding: 20,
                  fontColor: '#9a9a9a'
                }
              }
            ]
          }
        },
    }
  },
  mixins: [
    numberUtils,
    timeUtils
  ],
  computed: {
    ...mapState([
      'countries',
    ]),
    chartScoreData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'score': 'Score',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        if(name === 'Score'){
          color =   this.chartColors.default.info
        }else{
          color =   this.chartColors.default.primary
        }

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

    chartKeywordsData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'number_of_keywords': 'Number of Keywords',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

    chartPerformanceData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'revenue': 'Revenue',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        if(name === 'Revenue'){
          color =   this.chartColors.default.warning
        }else{
          color =   this.chartColors.default.primary
        }

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

    chartCPARPCData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'bid_amount': 'Bid Amount',
        'cpa_c': 'CPA(C)',
        'cpa_r': 'CPA(R)',
        'rpc_r': 'RPC(R)',
        'rpc_c': 'RPC(C)',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        if(name === 'Bid Amount'){
          color =   this.chartColors.default.info
        }else if(name === 'CPA(C)'){
          color =   this.chartColors.default.warning
        }else if(name === 'CPA(R)'){
          color =   this.chartColors.default.warningDark
        }else if(name === 'RPC(R)'){
          color =   this.chartColors.default.danger
        }else if(name === 'RPC(C)'){
          color =   this.chartColors.default.dangerDark
        }else{
          color =   this.chartColors.default.primary
        }

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

    chartClicksData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'clicks_in_r': 'Clicks In(R)',
        'clicks_in_c': 'Clicks In(C)',

        'clicks_out_r': 'Clicks Out(R)',
        'clicks_out_c': 'Clicks Out(C)',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        if(name === 'Clicks Out(R)' || name === 'Clicks In(R)'){
          color =   this.chartColors.default.info
        }else if(name === 'Clicks Out(C)' || name === 'Clicks In(C)'){
          color =   this.chartColors.default.warning
        }else{
          color =   this.chartColors.default.primary
        }

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

    chartCTRData () {
      let data = this.dataToChartPivot(this.data, 'date', {
        'ctr_r': 'CTR(R)',
        'ctr_c': 'CTR(C)',
      });

      let chartData = {
        datasets: [],
        labels: []
      },
          color;

      for(let name in data['dataset']){

        if(name === 'CTR(R)'){
          color =   this.chartColors.default.info
        }else if(name === 'CTR(C)'){
          color =   this.chartColors.default.warning
        }else{
          color =   this.chartColors.default.primary
        }

        chartData.datasets.push({
          fill: false,
          borderColor: color,
          borderWidth: 2,
          borderDash: [],
          label: name,
          borderDashOffset: 0.0,
          pointBackgroundColor: '#000',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: this.chartColors.default.primary,
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: data['dataset'][name]
        });
      }

      chartData.labels = data['labels'];

      return chartData;
    },

  },
  methods: {
    isMobile () {
      return !!(window.matchMedia("(max-width: 767px)").matches)
    },

    view () {
      this.isLoading = true;

      getTqAnalysis(
          this.selectedAdUnitCode,
          this.selectedCountryCode,
          moment(this.selectedDates[0]).format('YYYY-MM-DD'),
          moment(this.selectedDates[1]).format('YYYY-MM-DD')
      ).then(
              response => {
                this.isLoading = false;
                this.data = response.data.results;
              },
              error => {
                this.isLoading = false;
                alert('An error happens.');
                console.error(error);
              }
          );

      this.isLoadingOptimization = true;
    },

    dataToChartPivot (data, dateKey, labelKeys) {

      if(data.length === 0){
        return [];
      }

      // Create all Labels (For example: US, NL, etc.)
      let labels = {};
      for(let i in labelKeys){
        labels[i] = 0;
      }

      // Get all dates
      let minDate, maxDate, currentDate, momentDate;
      for(let i in data){
        currentDate = data[i][dateKey];
        momentDate = moment(currentDate);
        if(!minDate){
          minDate = maxDate = currentDate;
        }

        if(momentDate < moment(minDate)){
          minDate = currentDate;
        }

        if(momentDate > moment(maxDate)){
          maxDate = currentDate;
        }
      }

      let allDates = {};
      let currentMoment = moment(minDate).subtract(1, 'days');
      let endMoment = moment(maxDate);
      while (currentMoment.isBefore(endMoment, 'day')) {
        currentMoment.add(1, 'days');
        allDates[currentMoment.clone().format('YYYY-MM-DD')] = 0;
      }

      //reorganize data.
      let reorganizedData = {};
      for(let i in data){
        for(let labelKey in labelKeys) {
          // labelKeys[labelKey] = data[i][labelKey]
          if (typeof reorganizedData[labelKeys[labelKey]] === 'undefined') {
            reorganizedData[labelKeys[labelKey]] = {};
          }
          if (typeof reorganizedData[labelKeys[labelKey]][data[i][dateKey]] === 'undefined') {

            let amount = 0;

            if (data[i][labelKey]) {
              amount = data[i][labelKey];
            }

            reorganizedData[labelKeys[labelKey]][data[i][dateKey]] = amount;
          }
        }
      }

      allDates = Object.fromEntries(Object.entries(allDates).sort());

      // Add missing dates.
      for(let i in reorganizedData){
        reorganizedData[i] = {...allDates, ...reorganizedData[i] };
      }

      // convert objects to arrays.
      for(let i in reorganizedData){
        reorganizedData[i] = Object.fromEntries(Object.entries(reorganizedData[i]).sort());
        reorganizedData[i] = Object.values(reorganizedData[i]);
      }

      return {
        'dataset': reorganizedData,
        'labels': Object.keys(allDates)
      }
    },
  }
}
</script>
